const initialDepartment = {
    departmentPermissions:{},
    departmentLists: [],
    departmentStatus: [],
    changedDepartmentStatus : [],
    loadingDepartment: false,
    errorsDepartment: {}
}

const  departmentReducer = (department = initialDepartment, action) => {
    switch (action.type) {
        case "GET_DEPARTMENTLIST_PENDING":
        case "ADD_DEPARTMENT_PENDING":
        case "UPDATE_DEPARTMENT_PENDING":
        case "UPDATE_DEPARTMENT_STATUS_PENDING":
        case "DELETE_DEPARTMENT_PENDING":
        case "GET_DEPARTMENTLISTBYID_PENDING":
            return { ...department, loadingDepartment: true };

        case "GET_DEPARTMENTLIST_FULFILLED":
            return {
                ...department,
                loadingDepartment: false,
                departmentLists: action.payload,
                departmentCount: action.departmentCount,
                departmentPermissions:action.permissions,
            };

        case "ADD_DEPARTMENT_FULFILLED":
            return {
                ...department,
                loadingDepartment: false,
                changedDepartmentStatus: action.payload,
            };

        case "UPDATE_DEPARTMENT_FULFILLED":
            return {
                ...department,
                loadingDepartment: false,
                changedDepartmentStatus: action.payload,
            };

        case "UPDATE_DEPARTMENT_STATUS_FULFILLED":
            return {
                ...department,
                loadingDepartment: false,
                changedDepartmentStatus: action.payload,
            };

        case "GET_DEPARTMENTLISTBYID_FULFILLED":
            return {
                ...department,
                loadingDepartment: false,
                departmentLists: action.payload
            };

        case "DELETE_DEPARTMENT_FULFILLED":
            return {
                ...department,
                loadingDepartment: false,
                changedDepartmentStatus: action.payload
            };

        case "RESET_DELETE_DEPARTMENT_STATUS":
            return {
                ...department,
                loadingDepartment: false,
                changedDepartmentStatus: [],
                errorsDepartment:{}
            };

        case "GET_DEPARTMENTLIST_REJECTED":
        case "ADD_DEPARTMENT_REJECTED":
        case "UPDATE_DEPARTMENT_REJECTED":
        case "UPDATE_DEPARTMENT_STATUS_REJECTED":
        case "DELETE_DEPARTMENT_REJECTED":
        case "GET_DEPARTMENTLISTBYID_REJECTED":
            return {
                ...department,
                loadingDepartment: false,
                errorsDepartment: action.payload
            };

        default:
            return department;
    }
}

export default departmentReducer;